import { render, staticRenderFns } from "./TextInputControl.vue?vue&type=template&id=8bb654b8&scoped=true&"
import script from "./TextInputControl.vue?vue&type=script&lang=ts&"
export * from "./TextInputControl.vue?vue&type=script&lang=ts&"
import style0 from "./TextInputControl.vue?vue&type=style&index=0&id=8bb654b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb654b8",
  null
  
)

export default component.exports